import { ArrowRight, Certificate } from "@phosphor-icons/react";

export default function Hero({ t }) {
  return (
    <section id="top" className="bg-[#0B1B3D] text-white min-h-[75vh] flex items-center">
      <div className="max-w-7xl mx-auto w-full px-6 py-24 lg:px-12">
        <div className="max-w-3xl">
          <p className="text-xs font-semibold tracking-[0.2em] uppercase text-[#8FA1B5] mb-8" data-testid="hero-overline">
            {t.hero.overline}
          </p>
          <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight leading-[1.05] mb-8" data-testid="hero-title">
            {t.hero.title}
          </h1>
          <p className="text-base md:text-lg leading-relaxed text-white/70 max-w-xl mb-5" data-testid="hero-subtitle">
            {t.hero.subtitle}
          </p>
          <p className="text-sm tracking-wide text-[#8FA1B5] mb-12" data-testid="hero-tagline">
            {t.hero.tagline}
          </p>
          <div>
            <a
              href="#contact"
              data-testid="hero-cta-button"
              className="inline-flex items-center gap-3 bg-white text-[#0B1B3D] font-medium px-8 py-4 hover:bg-[#E2E8F0] transition-colors"
            >
              {t.cta}
              <ArrowRight size={18} weight="light" />
            </a>
          </div>
          <div className="mt-16 pt-8 border-t border-white/15 flex items-center gap-3 text-sm text-white/60" data-testid="hero-experience">
            <Certificate size={20} weight="light" className="text-[#8FA1B5] shrink-0" />
            {t.hero.experience}
          </div>
        </div>
      </div>
    </section>
  );
}
